import { takeLatest, put, call, fork } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';
import * as actionTypes from 'constants/ActionTypes';

import * as actions from '../actions/extensionActions';

function* fetchExtensionsWorker(action) {
  const { request } = action.payload;
  try {
    const response = yield call(restClient.request, request);
    yield put(actions.fetchExtensionsSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchExtensionsFailure(error));
  }
}

function* fetchExtensionsWatcher() {
  yield takeLatest(actionTypes.FETCH_EXTENSIONS_REQUEST, fetchExtensionsWorker);
}

const extensionSagas = [fork(fetchExtensionsWatcher)];
export default extensionSagas;
